import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './rankingclientecsat.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { carregarGrafico, filterHandle } from './redux/rankingclientecsatActions'
import { setInfoEmpresa, setProjeto } from '../../../layout/redux/layoutActions'
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'


export default () => {
  const dispatch = useDispatch()
  const { filters, empresas, empresa, usuario: {nomeEmpresa}, sistema } = useSelector(state=> state.layoutState)
  const { projeto, grafico, totalAvaliacao, projetos, filtersProvisorio } = useSelector(state=> state.rankingclientecsatState)

  const nls = require(`../rankingclientecsat/nls/${sistema.idioma}.json`)
  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])


  useEffect(()=> {
    if (projeto.id) {
      dispatch(filterHandle({projetoID: projeto.id, empresaId: empresa.empresaId, params: {...filters, NomeEmpresa: nomeEmpresa}, filtersProvisorio, typeSelect: filters.typeSelect, idioma: sistema.idiomaIdValue}))
    }
  }, [projeto, empresa, sistema.idiomaIdValue])

  const handleFormFilter = (e) => {
    dispatch(setProjeto(e.value))
  }

  const handleFormFilterEmpresa = (e) => {
    dispatch(setInfoEmpresa(e.value))
  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}

  
  return (
    <div className='box-rankingclientecsat' data-cy='page-csatstores'>
      <div className='box-rankingclientecsat-topinfo'>
        <div>
          <div className='box-rankingclientecsat-topinfo-select'>
            <Select 
              name='projeto'
cy='filter-project'
label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          <div className='box-rankingclientecsat-topinfo-select'>
            <Select 
              name='empresa'
cy='filter-company'
label={nls.empresaanalisada}
              options={empresas}
              selected={empresa}
              action={(e)=> handleFormFilterEmpresa(e)}
              selectedItem={false}
              optionLabel='descricaoEmpresa'
              optionValue='empresaId'
            />
          </div>
        </div>
        <div className='box-rankingclientecsat-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong data-cy='feedback-count'>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video7" cy="tutorial" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
  cy="dashboard-create-open"
  onClick={handleAbrirCriarDashboard}
/>
        )}

      </div>
      
      <Grafico nlsContexto={nlsContexto} nls={nls} imprimir={totalAvaliacao > 0}/>

      <Criar />
      
    </div>
  )
}
